import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { jwtDecode } from 'jwt-decode'
import { initializeMsal, loginRequest, msalInstance } from '../auth'

interface DecodedToken extends Record<string, unknown> {
    given_name?: string
    family_name?: string
    country?: string
    city?: string
    oid?: string
    emails?: string[]
}

export const getAccessToken = async (): Promise<string> => {
    await initializeMsal()

    const accounts = msalInstance.getAllAccounts()
    if (accounts.length === 0) {
        throw new Error('No accounts found')
    }

    const account = accounts[0]

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account,
        })
        return response.accessToken
    } catch (error) {
        if (!(error instanceof InteractionRequiredAuthError)) {
            console.error('Error acquiring token:', error)
        }

        throw error
    }
}

export const extractUserInfo = async (
    fetchAccessToken: () => Promise<string> = getAccessToken
): Promise<{
    oid: string
    givenName: string
    familyName: string
    country: string
    city: string
    token: string
    email: string
}> => {
    const token = await fetchAccessToken()
    const decodedToken = jwtDecode(token) as DecodedToken
    const givenName = decodedToken.given_name || ''
    const familyName = decodedToken.family_name || ''
    const country = decodedToken.country || ''
    const city = decodedToken.city || ''
    const oid = decodedToken.oid || ''
    const email = (decodedToken.emails && decodedToken.emails[0]) || ''

    return { oid, givenName, familyName, country, city, token, email }
}
